import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import optimizationOptionReducer from './slices/optimizationOptionSlice';
import uploadAndAnalyzeAiReducer from './slices/uploadAndAnalyzeAI';
const store = configureStore({
  reducer: {
    user: userReducer,
    optimizationOptionData: optimizationOptionReducer,
    uploadAndAnalyzeAiState: uploadAndAnalyzeAiReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
